import api from "./api";

export default {
  users: [],

  async getInvitationStatus(token) {
    let response = await api.get(`/saas-user/invite/${token}`);
    return response.data;
  },

  async getUsersCount(clientId = null) {
    let url = "/accountHolder/count";
    if (clientId) {
      url += `?ClientID=${clientId}`;
    }
    let response = await api.get(url);
    return response.data?.at(0);
  },

  async getUserProfileData(userId, clientId = null) {
    let url = `saas-user/count/${userId}`;
    if (clientId) {
      url += `?ClientID=${clientId}`;
    }
    let response = await api.get(url);
    console.log("XXXXX === ", response);
    return response?.data?.data;
  },

  async getUserById(userId, clientID = 0) {
    let res = await api.get(`saas-user/${userId}?ClientID=${clientID}`);
    return res.data?.at(0);
  },

  async getAllUsers(clientId = null) {
    let response = await api.get(`saas-user?ClientID=${clientId}`);
    this.users = response.data;
    return this.users;
  },

  async getFilteredOperators() {
    if (this.users == "") {
      return this.getOperators();
    }
    return this.users.filter((user) => !!user.SaasOperator);
  },

  async getOperators() {
    let response = await api.get("operators");
    return response.data;
  },

  async addUser(
    firstName,
    lastName,
    email,
    phone,
    isAdmin,
    isOperator,
    timezone
  ) {
    const userData = {
      firstName,
      lastName,
      email,
      phone,
      isAdmin,
      isOperator,
      timezone,
    };

    let response = await api.post("saas-user/invite", userData);
    return response.data;
  },

  async updateUser(
    firstName,
    lastName,
    email,
    phone,
    isAdmin,
    isOperator,
    timezone,
    userId
  ) {
    const userData = {
      firstName,
      lastName,
      email,
      phone,
      isAdmin,
      isOperator,
      userId,
      timezone,
    };

    let response = await api.post("user/edit", userData);
    return response.data;
  },

  async updateInvitation(
    firstName,
    lastName,
    email,
    phone,
    isAdmin,
    isOperator,
    inviteId
  ) {
    const invitationData = {
      firstName,
      lastName,
      email,
      phone,
      isAdmin,
      isOperator,
      inviteId,
    };

    let response = await api.post("saas-user/invite/edit", invitationData);
    return response.data;
  },

  async deleteUser(userId) {
    let res = await api.delete(`/saas-user/${userId}`);
    return res.data;
  },

  async deleteInvitation(userId) {
    let res = await api.delete(`/saas-user/invitation/${userId}`);
    return res.data;
  },

  async transferData(from, to) {
    let res = await api.post("transfer", {
      operatorId: to,
      transferOperatorId: from,
    });
    return res.data;
  },

  async getAccountHolder(clientId = null) {
    let url = '/saas-user/get/account-Holder';
    if (clientId) {
      url += `?ClientID=${clientId}`;
    }
    let res = await api.get(url);
    return res.data;
  },

  async getInvitation(email) {
    let res = await api.get(
      `/saas-user/invitation?email=${encodeURIComponent(email)}`
    );
    return res.data;
  },

  // Used by the magic link flow to tell a returning user from a new one.
  // Note: the backend increments LoginCount on every call for an active user.
  async isUserAllowed(email) {
    let res = await api.get(`/isuserallowed?email=${encodeURIComponent(email)}`);
    return res.data;
  },

  async sendMagicLink(email) {
    // The backend falls back to the mobile console's redirect URL when this is
    // omitted, so it always has to be sent from here.
    const redirectUrl =
      process.env.VUE_APP_MAGIC_LINK_REDIRECT_URL ||
      `${window.location.origin}/login`;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
    let res = await api.post("/auth/magic-link", {
      email,
      redirectUrl,
      timezone,
    });
    return res.data;
  },

  // Creates the SaaS user before the magic link goes out, the way sig2_web's
  // sign up does. main.js also creates one post sign in, and the backend's
  // SignUpWithOrGetEmailUser is get-or-create, so calling both is safe. Doing
  // it here is what keeps the name off the localStorage bridge, which is lost
  // when the emailed link is opened on another device.
  async createSaasUser({ firstName, lastName, email }) {
    let res = await api.post("/savesaasuser", {
      FirstName: firstName,
      LastName: lastName,
      Email: email,
      UserName: email,
      SSOType: "Email",
    });
    const data = res.data;
    // A duplicate is the user already existing, which is not a failure here.
    if (data?.success === false && !/Duplicate entry/i.test(data.message || "")) {
      throw new Error(data.message || "Unable to create account.");
    }
    return data;
  },

  async saveSaasClientSetting(shareContact, viewMessages) {
    let res = await api.patch(
      `/saas-client/setting?shareContact=${shareContact}&viewMessage=${viewMessages}`
    );
    return res.data;
  },

  async getSaasClientSetting() {
    let res = await api.get(`/saas-client/setting`);
    return res.data;
  },

  async getUserUsage(clientId = null) {
    let url = `/saas-client/usage`;
    if (clientId) {
      url += `?ClientID=${clientId}`;
    }
    let res = await api.get(url);
    return res.data;
  },

  async getStripeToken() {
    let res = await api.post("/saas-client/payment-method");
    return res.data;
  },

  async getBillingUrl() {
    let res = await api.get("/saas-client/invoice");
    return res.data;
  },

  async getFreeTrialStatus(clientId = null) {
    let url = "/saas-client/free-trial";
    if (clientId) {
      url += `?ClientID=${clientId}`;
    }
    let res = await api.get(url);
    return res.data;
  },

  async activateAccount() {
    let res = await api.post("/saas-client/activate");
    return res.data;
  },

  async getNewProjectedPrice(projectedPrice, currentPrice, newMessageCount) {
    let res = await api.get(
      `/saas-client/project-price?ProjectedPrice=${projectedPrice}&currentPrice=${currentPrice}&newMessageCount=${newMessageCount}`
    );
    return res.data;
  },

  async updateMessages(newCount) {
    let res = await api.patch(
      `/saas-client/messages?messagesCount=${newCount}`
    );
    return res.data;
  },

  async transferAccount(toUserId) {
    let res = await api.post("/saas-client/transfer-ownership", {
      transferUserID: toUserId,
    });
    return res.data;
  },
};
